import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import moment from 'moment';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { useForm } from '@/form/useForm.ts';

export const PersonalInfoSummaryFormPL = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({
    slideIds: ['bmi'],
  });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const birthdateLabel = translate({
    pl: 'Data urodzenia',
    en: 'Date of birth',
  });
  const birthdateRawValue = getFieldValue('birthdate') as string | undefined;
  const parsedBirthdate = moment(birthdateRawValue, ['DD.MM.YYYY', 'YYYY-MM-DD'], true);
  const birthdateValue = parsedBirthdate.isValid() ? parsedBirthdate.format('DD.MM.YYYY') : birthdateRawValue || '-';

  const heightField = s.bmi.fields.find(({ name }) => name === 'height');
  const heightLabel = translate(heightField?.label);

  const weightField = s.bmi.fields.find(({ name }) => name === 'weight');
  const weightLabel = translate(weightField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-personal-info'}>
      <h2>{translate(s.dataSummary.titles?.personalInfo)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{birthdateLabel}</div>
        <div className={'value'}>{birthdateValue}</div>
        <div className={'label'}>{heightLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('height')}
          {editMode && <EditDataField field={heightField!} slideId={'bmi'} />}
        </div>

        <div className={'label'}>{weightLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('weight')}
          {editMode && <EditDataField field={weightField!} slideId={'bmi'} />}
        </div>
      </div>
    </div>
  );
};
